import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError, useApi } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { AdminTitle, StatusPill, Table } from "./AdminUi";

export default function AdminArticles() {
  const { user } = useAuth();
  const { data, reload } = useApi("/admin/articles");
  const [hub, setHub] = useState("");
  const toggle = async (a) => {
    try {
      const { data: full } = await api.get(`/admin/articles/${a.id}`);
      const { id, _id, created_at, updated_at, order, published_at, ...payload } = full;
      await api.put(`/admin/articles/${a.id}`, { ...payload, status: a.status === "published" ? "draft" : "published" });
      toast.success(a.status === "published" ? "Article unpublished" : "Article published");
      reload();
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  const remove = async (a) => {
    if (!window.confirm(`Delete "${a.title}"? This can't be undone.`)) return;
    try {
      await api.delete(`/admin/articles/${a.id}`);
      toast.success("Article deleted");
      reload();
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  const rows = (data || []).filter((a) => !hub || a.hub === hub);
  return (
    <div data-testid="admin-articles">
      <AdminTitle title="Articles" actions={<Link to="/admin/articles/new" className="btn-primary" data-testid="admin-new-article-btn">New article</Link>}>Create, edit, publish and unpublish Direction and Understanding content.</AdminTitle>
      <div className="mb-4 flex gap-2">
        {[["", "All"], ["direction", "Direction"], ["understanding", "Understanding"]].map(([v, l]) => (
          <button key={v} onClick={() => setHub(v)} className={`rounded-full px-4 py-2 text-sm font-semibold border ${hub === v ? "bg-ink text-cream" : "bg-white"}`} data-testid={`admin-articles-filter-${v || "all"}`}>{l}</button>
        ))}
      </div>
      <Table head={["Title", "Hub", "Category", "Status", "Review", "Actions"]} testId="admin-articles-table">
        {rows.map((a) => (
          <tr key={a.id} data-testid={`admin-article-row-${a.slug}`}>
            <td className="px-4 py-3 font-medium">{a.title}</td>
            <td className="px-4 py-3 capitalize">{a.hub}</td>
            <td className="px-4 py-3">{a.category}</td>
            <td className="px-4 py-3"><StatusPill status={a.status} /></td>
            <td className="px-4 py-3 text-xs">{a.review_status === "expert_reviewed" ? "Reviewed" : "Pending"}</td>
            <td className="px-4 py-3 whitespace-nowrap space-x-3">
              <Link to={`/admin/articles/${a.id}`} className="btn-ghost" data-testid={`admin-edit-article-${a.slug}`}>Edit</Link>
              <button onClick={() => toggle(a)} className="btn-ghost" data-testid={`admin-toggle-article-${a.slug}`}>{a.status === "published" ? "Unpublish" : "Publish"}</button>
              {user.role === "admin" && <button onClick={() => remove(a)} className="btn-ghost !text-clay-dark" data-testid={`admin-delete-article-${a.slug}`}>Delete</button>}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
